import ThruOrTeetime from './thru-or-teetime'

export default ThruOrTeetime
